import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [RouterModule.forChild([
    {
      path: '',
      data: { breadcrumb : '' },
      loadChildren: () => import('./chamado-franquia-listar/chamado-franquia-listar.module')
      .then(m => m.ChamadoFranquiaListarModule) 
    },
    {
      path: 'chat',
      data: { breadcrumb : 'Chat' },
      loadChildren: () => import('./chamado-franquia-chat/chamado-franquia-chat.module')
      .then(m => m.ChamadoFranquiaChatModule) 
    },
    {
      path: 'inserir',
      data: { breadcrumb : 'Novo' },
      loadChildren: () => import('./chamado-franquia-inserir/chamado-franquia-inserir.module')
      .then(m => m.ChamadoFranquiaInserirModule) 
    },
    {
      path: 'encerrar',
      data: { breadcrumb : 'Encerrar' },
      loadChildren: () => import('./chamado-franquia-encerrar/chamado-franquia-encerrar.module')
      .then(m => m.ChamadoFranquiaEncerrarModule)
    },
    {
      path: 'base-conhecimento',
      data: { breadcrumb : 'Base de Conhecimento' },
      loadChildren: () => import('./base-conhecimento/base-conhecimento.module')
      .then(m => m.BaseConhecimentoModule)
    },
    {
      path: 'monitoramento',
      data: { breadcrumb : 'Monitoramento' },
      loadChildren: () => import('./monitoramento/monitoramento.module')
      .then(m => m.MonitoramentoModule)
    }
    
  ])],
  exports: [RouterModule]
})
export class ChamadoFranquiaRoutingModule { }
